import useWindowSize from "@/hooks/useWindowSize"
import { Box } from "@mui/material"
import { Instance } from "@popperjs/core"
import React, { FC, useEffect, useRef } from "react"
import { RelendTooltip } from "../relendTooltip"
import * as styles from "./styles"

type LiquidationProgressProps = {
  currentProgress: number
  progressWidth: number
  borrowLimit: number
  liquidationThreshold: number
  setProgressWidth: React.Dispatch<React.SetStateAction<number>>
  currentProgressTitle?: string
  borrowLimitTitle?: string
  liquidationThresholdTitle?: string
  supplyTitle?: string
}

const View: FC<LiquidationProgressProps> = ({
  currentProgress,
  progressWidth,
  borrowLimit,
  liquidationThreshold,
  setProgressWidth,
  currentProgressTitle = "",
  borrowLimitTitle = "",
  liquidationThresholdTitle = "",
  supplyTitle = "",
}) => {
  const { width } = useWindowSize()
  const ref = useRef<HTMLDivElement | null>(null)
  const positionRef = React.useRef<{ x: number; y: number }>({
    x: 0,
    y: 0,
  })
  const popperRef = React.useRef<Instance>(null)
  const areaRef = React.useRef<HTMLDivElement>(null)

  const handleMouseMove = (event: React.MouseEvent) => {
    positionRef.current = { x: event.clientX, y: event.clientY }

    if (popperRef.current != null) {
      popperRef.current.update()
    }
  }

  useEffect(() => {
    if (ref.current) {
      setProgressWidth(ref.current.offsetWidth)
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [ref, width])

  return (
    <Box sx={styles.floatingProgressWrapper} ref={ref}>
      <RelendTooltip
        title={supplyTitle}
        PopperProps={{
          popperRef,
          anchorEl: {
            getBoundingClientRect: () => {
              return new DOMRect(positionRef.current.x, areaRef.current!.getBoundingClientRect().y, 0, 0)
            },
          },
        }}
      >
        <Box ref={areaRef} onMouseMove={handleMouseMove} sx={styles.floatingProgressGreyBackground} />
      </RelendTooltip>

      {currentProgress > 0 && (
        <RelendTooltip title={currentProgressTitle}>
          <Box sx={styles.floatingCurrentProgess} width={`${currentProgress * progressWidth}px`}>
            <Box sx={styles.floatingCurrentProgressWave} />
          </Box>
        </RelendTooltip>
      )}
      {borrowLimit > 0 && (
        <RelendTooltip title={borrowLimitTitle}>
          <Box sx={styles.floatingBorrowLimitPoint} left={`${borrowLimit * progressWidth}px`} />
        </RelendTooltip>
      )}
      {liquidationThreshold > 0 && (
        <RelendTooltip title={liquidationThresholdTitle}>
          <Box sx={styles.floatingLiquidationThresholdPoint} left={liquidationThreshold * progressWidth} />
        </RelendTooltip>
      )}
    </Box>
  )
}

export default View
